import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { TestPage } from './test/test.page'
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import {AddfriendPage} from './addfriend/addfriend.page';
import { HttpClientModule, HttpClient} from '@angular/common/http';

import { FormsModule } from '@angular/forms';
import{LoginPage} from './login/login.page';
import{RegisterPage} from './register/register.page';

// import { Camera } from '@awesome-cordova-plugins/camera/ngx';

// class CameraMock extends Camera {
//   getPicture(options) {
//     return new Promise((resolve, reject) => {
//       resolve('BASE_64_ENCODED_DATA_GOES_HERE');
//     });
//   }
// }

@NgModule({
  declarations: [
    AppComponent,
    TestPage,AddfriendPage,LoginPage,RegisterPage
    
  ],
  imports: [BrowserModule, IonicModule.forRoot(), AppRoutingModule,HttpClientModule,FormsModule],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy}, 
    // { provide: Camera, useClass: CameraMock }
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    AppComponent,
    TestPage
    
  ],

})
export class AppModule { }
